export default __webpack_public_path__ + "static/media/yayinlar3.48392a96.png";